module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2), exports);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var style_1 = __webpack_require__(3);
var React = __webpack_require__(4);
var styles = __webpack_require__(5);
var MultilineTextField = /** @class */ (function (_super) {
    tslib_1.__extends(MultilineTextField, _super);
    function MultilineTextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (event) {
            _this.props.onValueChange(event.currentTarget.value);
        };
        return _this;
    }
    MultilineTextField.prototype.componentDidMount = function () {
        // Trigger scroll check
        this.forceUpdate();
    };
    MultilineTextField.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.value !== prevProps.value) {
            // Trigger scroll check
            this.forceUpdate();
        }
    };
    MultilineTextField.prototype.render = function () {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, containerStyle = _a.containerStyle, inputStyle = _a.inputStyle, invalid = _a.invalid, lengthStyle = _a.lengthStyle, maxLength = _a.maxLength, name = _a.name, onBlur = _a.onBlur, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, onKeyPress = _a.onKeyPress, onKeyUp = _a.onKeyUp, placeholder = _a.placeholder, required = _a.required, value = _a.value;
        return (React.createElement("div", tslib_1.__assign({}, style_1.mergeStyles(styles['container'], required && styles['required'], containerStyle)),
            React.createElement("textarea", tslib_1.__assign({ ref: function (textArea) { return _this.textArea = textArea; } }, style_1.mergeStyles(styles['input'], invalid && styles['invalid'], inputStyle), { rows: this.calculateRowsCount(), disabled: disabled, placeholder: placeholder, value: value, onChange: this.onChange, onKeyDown: onKeyDown, onBlur: onBlur, onFocus: onFocus, onKeyPress: onKeyPress, onKeyUp: onKeyUp, name: name })),
            this.isTextLengthVisible() &&
                React.createElement("span", tslib_1.__assign({}, style_1.mergeStyles(styles['text_length'], this.props.disabled && styles['text_length-disabled'], (this.hasScroll() && styles['text_length-scroll']) || undefined, (maxLength && this.calculateTextLength(maxLength) < 0 && styles['invalid']) || undefined, lengthStyle)), maxLength && this.calculateTextLength(maxLength))));
    };
    MultilineTextField.prototype.blur = function () {
        if (this.textArea) {
            this.textArea.blur();
        }
    };
    MultilineTextField.prototype.hasScroll = function () {
        if (!this.textArea) {
            return false;
        }
        return this.textArea.scrollHeight > this.textArea.clientHeight;
    };
    MultilineTextField.prototype.calculateRowsCount = function () {
        var rows = this.props.value.split('\n').length;
        return this.props.minRows && rows < this.props.minRows
            ? this.props.minRows
            : rows;
    };
    MultilineTextField.prototype.calculateTextLength = function (maxLength) {
        return maxLength - this.props.value.length;
    };
    MultilineTextField.prototype.isTextLengthVisible = function () {
        return typeof this.props.maxLength === 'number';
    };
    MultilineTextField.defaultProps = {
        minRows: 1,
    };
    return MultilineTextField;
}(React.Component));
exports.MultilineTextField = MultilineTextField;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var isStyleProps = function (styleProps) {
    return typeof styleProps === 'object' && ('style' in styleProps && 'className' in styleProps);
};
var reduce = function (acc, style) {
    if (typeof style === 'string') {
        acc.className += acc.className.length === 0
            ? style
            : " " + style;
    }
    else if (typeof style === 'object') {
        if (isStyleProps(style)) {
            acc.className += acc.className.length === 0
                ? style.className
                : " " + style.className;
            Object.assign(acc.style, style.style);
        }
        else if (Array.isArray(style)) {
            return style.reduce(reduce, acc);
        }
        else {
            Object.assign(acc.style, style);
        }
    }
    return acc;
};
function mergeStyles() {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    return styles.reduce(reduce, { style: {}, className: '' });
}
exports.mergeStyles = mergeStyles;
//# sourceMappingURL=style.js.map

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"multiline_text_field_component-container-iwxkNce5ZmE","input":"multiline_text_field_component-input-i9vk9dJlqoo","required":"multiline_text_field_component-required-2iBy9lovsM6","text_length":"multiline_text_field_component-text_length-2vv3m8xHgcw","text_length-scroll":"multiline_text_field_component-text_length-scroll-6MJjOC95V60","invalid":"multiline_text_field_component-invalid-hha30Gv612W","text_length-disabled":"multiline_text_field_component-text_length-disabled-eJXsoCZg1GU"};

/***/ })
/******/ ]);
//# sourceMappingURL=frontend-component-multiline-text-field.js.map